import script from "./NewsDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsDetails.vue?vue&type=script&lang=ts&setup=true"

import "./NewsDetails.vue?vue&type=style&index=0&id=667f9b85&lang=css&scoped=true"
import "./NewsDetails.vue?vue&type=style&index=1&id=667f9b85&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667f9b85"]])

export default __exports__